import type { ReactNode } from 'react';
import { Navigate } from '../lib/routing';
import { useAuth } from '../hooks/use-auth';
import FullPageSpinner from './full-page-spinner';

export default function ProtectedRoute({ children }: { children: ReactNode }) {
  const { session, loading } = useAuth();

  if (loading) return <FullPageSpinner />;

  if (!session) {
    return <Navigate to="/sign-in" replace />;
  }

  return <>{children}</>;
}
